import api from "./../api/axios";
import endpoints from "./../api/endpoints";

export const fetchAllUsers = async () => {
    return await api.get(endpoints.users.getAll);
};

export const getInitialMatches = async (page = 1, size = 8) => {
    return await api.get(endpoints.user.matches.initial, {
        params: {
            page,
            size
        }
    });
};

export const getLikesSent = async ()=> {
    return await api.get(endpoints.user.getLikesSent);
}

export const getLikesReceived = async ()=> {
    return await api.get(endpoints.user.getLikesReceived);
}

export const getSearchMatches = async (postBody) => {
    return await api.post(endpoints.user.matches.search, postBody);
};

export const getFilteredMatches = async (postBody) => {
    return await api.post(endpoints.user.matches.filter, postBody);
};

export const fetchUser = async (id) => {
    const url = endpoints.user.get.replace('{userId}', id);
    return await api.get(url);
};

export const getCurrentUser = async () => {
    return await api.get(endpoints.user.me);
}

export const getUserProfile = async (id) => {
    const userProfile = await api.get(endpoints.user.profile.replace('{userId}', id));
    return userProfile;
}

export const saveLocation = async (postPayload) => {
    const locationSaved = await api.post(endpoints.api.locationSave, postPayload);
    return locationSaved;
}

export const updateUserProfile = async (postBody) => {
    return await api.patch(endpoints.user.update.profile, postBody);
}

export const updateUserPassword = async (postBody) => {
    return await api.post(endpoints.auth.updatePassword, postBody);
}

export const updateUserLocation = async (postBody) => {
    return await api.post(endpoints.user.saveLocation, postBody)
}

export const getUserImagesAll = async (userId) => {
    const userImagesAll = await api.get(endpoints.user.images.getAll.replace('{userId}', userId));
    return userImagesAll;
}

export const saveProfileImage  = async (formData, onUploadProgress) => {
    return await api.post(endpoints.user.images.upload.profileImage, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress
    });
}

export const deleteProfileImage  = async (imageUrl) => {
    return await api.delete(endpoints.user.images.delete.profileImage, {
    params: { imageUrl }
  });
}

export const saveGalleryImages  = async (formData, onUploadProgress) => {
    return await api.post(endpoints.user.images.upload.galleryImage, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress
    });
}

export const deleteGalleryImage  = async (imageUrl) => {
    return await api.delete(endpoints.user.images.delete.galleryImage, {
    params: { imageUrl }
  });
}

export const promotoGalleryImage = async (imageUrl) => {
    return await api.put(endpoints.user.images.promoteGalleryImage, null, {
        params: { imageUrl }
    });
}

export const getUserImagesByType = async (userId, type) => {
    const userImages = await api.get(`${endpoints.user.images.getByType.replace('{userId}', userId)}?type=${type}`);
    return userImages;
}

export const getUserImagesById = async (userId) => {
    const userImages = await api.get(`${endpoints.user.images.getByType.replace('{userId}', userId)}`);
    return userImages;
}

export const sendLikeToUser = async (userId) => {
  // POST request to backend to like user
  return await api.post(`/users/${userId}/like`);
};

export const sendFriendRequestToUser = async (userId) => {
  // POST request to send friend request
  return await api.post(`/friends/request/${userId}`);
};

export const addToFavorites = async (userId) => {
  // POST request to add to favorites
  return await api.post(`/favorites/${userId}`);
};